import { merge } from '../../helper';

import * as exRadio from '../../forms/radio';
import * as exLink from '../link';
import * as exElement from '../element';

// ----------------------------------------------------------------------------

function toggle(config: Record<string, any> = {}): Record<string, any> {
    // Default Config
    const defConfig: Record<string, any> = {
        radio: {
            data: ['Off', 'On'],
        },
    };

    // Merge
    merge(defConfig, config);

    // ------------------------------------------------------------------------

    //
    const elements: Record<string, any> = {};

    // Create element (div)
    const elSwitch = exElement.create({
        merge: defConfig,
        class: {
            new: 'switch-' + defConfig.type + ' alert alert-light',
        },
    });
    elements.element = elSwitch;

    // Create element (radio)
    const radio = exRadio.create(defConfig.radio);

    // Foreach Radio List
    for (const item of radio.list) {
        elSwitch.appendChildren([item.input, item.label]);
    }

    // Create element (link)
    const link = exLink.create({
        merge: defConfig.button,
        class: {
            new: 'btn btn-primary',
        },
    });
    elSwitch.appendChild(link.element);

    // Return
    return elements;
}

// ----------------------------------------------------------------------------

export { toggle };
